import React, { useRef } from 'react';
import { Carousel } from './carousel.react-component';
import { useCarouselFocusOrder } from './use-carousel-focus-order';
/**
 * Carousel wrapper that integrates the accessibility focus order hook.
 *
 * @remarks
 * This component wraps the standard Carousel with the useCarouselFocusOrder hook
 * to provide proper keyboard navigation and focus management for accessibility.
 *
 * Use this component instead of the base Carousel to ensure focus moves correctly:
 * 1. From the last focusable element before the carousel
 * 2. Into the focusable elements visible in the carousel scroll port
 * 3. To the post-content focusables (next/previous buttons, first element after carousel)
 *
 * @example
 * ```tsx
 * <CarouselWithFocusOrder showPager={true} allowScroll={false}>
 *   {items.map((item) => <Card key={item.id} {...item} />)}
 * </CarouselWithFocusOrder>
 * ```
 */

export function CarouselWithFocusOrder(props) {
  const carouselRef = useRef(null);
  useCarouselFocusOrder(carouselRef);
  return /*#__PURE__*/React.createElement(Carousel, Object.assign({}, props, {
    containerRef: carouselRef
  }));
}
CarouselWithFocusOrder.displayName = 'CarouselWithFocusOrder';
//# sourceMappingURL=carousel-with-focus-order.react-component.js.map